import { Box, Stack, useTheme } from "@mui/material";

interface ILayoutContentWrapper {
  children: React.ReactNode;
}

const LayoutContentWrapper = ({ children }: ILayoutContentWrapper) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        width: "100%",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: {
            xs: "100%",
            sm: "100%",
            md: "1180px",
            lg: "1440px",
            xl: "1920px",
          },
          px: {
            xs: theme.spacing(2),
            sm: theme.spacing(3),
            md: theme.spacing(4),
          },
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default LayoutContentWrapper;
